import React from 'react';

import DestinationMarker from './icons/destination-marker';
import DriverMarker from './icons/driver-marker';
import StoreMarker from './icons/store-marker';
import StoreMarkerActiveSvg from './icons/store-marker-active';
import StoreMarkerDisabledSvg from './icons/store-marker-disabled';
import StoreMarkerFavorite from './icons/store-marker-fav';
import StoreMarkerFavClosed from './icons/store-marker-fav-closed';
import UserMarker from './icons/user-marker';
import { IMarker, IMarkerInput, MarkerTypes } from './types';

export const SELECTED_STORE_MARKER_TYPES: readonly MarkerTypes[] = [
  MarkerTypes.StoreSelectedOpen,
  MarkerTypes.StoreSelectedClosed,
];

export const isSelectedStoreMarkerType = (type: MarkerTypes): boolean =>
  SELECTED_STORE_MARKER_TYPES.includes(type);

/**
 * Marker types drawn as the large teardrop instead of a dot. A teardrop marks its location
 * with its tip rather than its middle, so these have to be anchored differently.
 */
export const PIN_MARKER_TYPES: readonly MarkerTypes[] = [
  ...SELECTED_STORE_MARKER_TYPES,
  MarkerTypes.StoreInActive,
  MarkerTypes.DeliveryAddress,
];

export const isPinMarkerType = (type: MarkerTypes): boolean => PIN_MARKER_TYPES.includes(type);

export const deriveMarkerIcon = (type: MarkerTypes): React.ReactNode => {
  switch (type) {
    case MarkerTypes.User:
      return <UserMarker />;
    case MarkerTypes.StoreActive:
      return <StoreMarker />;
    case MarkerTypes.StoreInActive:
      return <StoreMarkerActiveSvg />;
    case MarkerTypes.StoreDisabled:
      return <StoreMarkerDisabledSvg />;
    case MarkerTypes.StoreFavClosed:
      return <StoreMarkerFavClosed />;
    case MarkerTypes.StoreFavOpen:
      return <StoreMarkerFavorite />;
    case MarkerTypes.Driver:
      return <DriverMarker />;
    case MarkerTypes.Destination:
      return <DestinationMarker />;

    default:
      throw new Error(`Unsupported type: ${type}`);
  }
};

export const checkSingleUseMarker = (type: MarkerTypes): boolean =>
  [
    MarkerTypes.User,
    MarkerTypes.Driver,
    MarkerTypes.Destination,
    MarkerTypes.DeliveryAddress,
  ].includes(type);

export const getKeyForMarkerInput = (
  { type, location }: IMarkerInput,
  isSingleUseMarker: boolean
): string => (isSingleUseMarker ? type : `${location.lat}${location.lng}`);

export const generateMarker = ({ type, location, onPress }: IMarkerInput): IMarker => {
  const isSingleUseMarker = checkSingleUseMarker(type);
  const key = getKeyForMarkerInput({ type, location }, isSingleUseMarker);
  return {
    key,
    location,
    icon: deriveMarkerIcon(type),
    onPress,
    type,
    preventMarkerPress: isSingleUseMarker,
  };
};
